package com.zq.webproject.utils

/**
 * Web平台系统分享工具实现
 * Web平台不显示分享功能
 */
actual object ShareUtils {
    /**
     * Web平台不支持分享
     */
    actual fun isShareSupported(): Boolean = false

    /**
     * Web平台不支持分享（空实现）
     */
    actual fun shareContent(title: String, text: String, url: String?) {
        println("ShareUtils - Web平台不支持系统分享")
    }
}
